// Custom Quick View Modal JavaScript

// Function to change modal image when thumbnail is clicked
function changeModalImage(newSrc, clickedThumbnail) {
    const modal = clickedThumbnail.closest('.custom-quick-modal');
    const modalImage = modal.querySelector('.modal-product-image');
    
    if (modalImage) {
      modalImage.src = newSrc;
    }
    
    // Update active thumbnail
    modal.querySelectorAll('.modal-thumbnail').forEach(thumb => {
      thumb.classList.remove('active');
    });
    clickedThumbnail.classList.add('active');
  }
  
  // Function to close modal
  function closeModal(modal) {
    modal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
    document.body.classList.remove('modal-open');
  }
  
  // Function to open modal
  function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      // Move modal to body to break out of any container
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
      
      modal.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
      document.body.classList.add('modal-open');
    }
  }
  
  
  
  
  
// Handle variant selection
function updateVariantSelection(form) {
  const optionSelects = form.querySelectorAll('.modal-option-select');
  const variantSelect = form.querySelector('.modal-variant-select');
  
  if (!variantSelect || optionSelects.length === 0) return;
  
  // Get selected options
  const selectedOptions = Array.from(optionSelects).map(select => select.value);
  console.log('Selected options:', selectedOptions);
  
  // Find matching variant
  const variants = Array.from(variantSelect.options).map(option => {
    try {
      // Try to parse JSON data first
      const variantData = option.getAttribute('data-variant-data');
      if (variantData) {
        const parsed = JSON.parse(variantData);
        return {
          id: option.value,
          title: parsed.title,
          available: parsed.available,
          options: parsed.options || []
        };
      }
    } catch (e) {
      console.log('Could not parse variant data, using fallback');
    }
    
    // Fallback to parsing text content
    return {
      id: option.value,
      title: option.textContent.split(' - ')[0],
      available: !option.disabled,
      options: option.textContent.split(' - ')[0].split(' / ')
    };
  });
  
  console.log('Available variants:', variants);
  
  const matchingVariant = variants.find(variant => {
    return selectedOptions.every((option, index) => 
      variant.options[index] === option
    );
  });
  
  console.log('Matching variant:', matchingVariant);
  
  if (matchingVariant) {
    variantSelect.value = matchingVariant.id;
    
    // Update add to cart button state
    const addButton = form.querySelector('.modal-add-to-cart-btn');
    const cartIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="cart-icon"><path d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.7 15.3C4.3 15.7 4.6 16.5 5.1 16.5H17M17 13V17C17 18.1 16.1 19 15 19H9C7.9 19 7 18.1 7 17V13M17 13H7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>';
    
    if (matchingVariant.available) {
      addButton.disabled = false;
      addButton.innerHTML = cartIcon + 'Add to cart';
      addButton.style.background = '';
      addButton.style.opacity = '';
    } else {
      addButton.disabled = true;
      addButton.innerHTML = cartIcon + 'Sold Out';
      addButton.style.background = '#ccc';
      addButton.style.opacity = '0.6';
    }
  }
}
  
  // Initialize modal functionality when DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    
    // Move all modals to body level to prevent container constraints
    const allModals = document.querySelectorAll('.custom-quick-modal');
    allModals.forEach(modal => {
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    });
    
    // Handle option changes
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('modal-option-select')) {
        const form = e.target.closest('.modal-product-form');
        if (form) {
          updateVariantSelection(form);
        }
      }
    });
    
    // Handle thumbnail clicks
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('modal-thumbnail')) {
        e.preventDefault();
        const newSrc = e.target.src.replace('width=80', 'width=500');
        changeModalImage(newSrc, e.target);
      }
    });
    
    // Close modal functionality
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('modal-overlay') || e.target.closest('.modal-close-btn')) {
        const modal = e.target.closest('.custom-quick-modal');
        if (modal) {
          closeModal(modal);
        }
      }
    });
    
    
    // Escape key to close modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const activeModal = document.querySelector('.custom-quick-modal.active');
        if (activeModal) {
          closeModal(activeModal);
        }
      }
    });
    
    // Let forms submit naturally like card-product does
    
  });
  
  // Add CSS for loading spinner animation
  const style = document.createElement('style');
  style.textContent = `
    .loading-spinner {
      animation: spin 1s linear infinite;
    }
    
    @keyframes spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    
    .modal-open {
      overflow: hidden !important;
    }
  `;
  document.head.appendChild(style);
  
// Function to update cart count immediately
function updateCartCountImmediately(cartData) {
  console.log('Updating cart count immediately with:', cartData);
  
  // Calculate non-upsell count (excluding cart-hidden products)
  let itemCount = cartData.item_count || 0;
  
  // Update cart count bubble in header
  const cartBubble = document.querySelector('.cart-count-bubble');
  const cartIcon = document.querySelector('#cart-icon-bubble');
  
  if (cartBubble) {
    const bubbleSpan = cartBubble.querySelector('span[aria-hidden="true"]');
    if (bubbleSpan) {
      bubbleSpan.textContent = itemCount;
    } else {
      cartBubble.innerHTML = `<span aria-hidden="true">${itemCount}</span><span class="visually-hidden">Cart count: ${itemCount}</span>`;
    }
    
    // Show/hide bubble based on count
    if (itemCount > 0) {
      cartBubble.style.display = '';
      cartBubble.classList.remove('hidden');
    } else {
      cartBubble.style.display = 'none';
    }
  } else if (itemCount > 0 && cartIcon) {
    // Create bubble if it doesn't exist
    const newBubble = document.createElement('div');
    newBubble.className = 'cart-count-bubble';
    newBubble.innerHTML = `<span aria-hidden="true">${itemCount}</span><span class="visually-hidden">Cart count: ${itemCount}</span>`;
    cartIcon.appendChild(newBubble);
  }
  
  // Update all possible cart count elements
  const cartCountSelectors = [
    '[data-cart-count]',
    '.cart-count',
    '#cart-count',
    '.cart-item-count',
    '.cart__count-bubble',
    '.header__icon--cart .visually-hidden',
    '.cart-link .cart-count'
  ];
  
  
  cartCountSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      if (element) {
        element.textContent = itemCount;
        if (itemCount > 0) {
          element.style.display = '';
          element.classList.remove('hidden');
        }
      }
    });
  });
  
  // Update cart drawer heading if it exists
  const drawerHeading = document.querySelector('.drawer__heading');
  if (drawerHeading) {
    const headingText = drawerHeading.textContent;
    // Replace any number in the heading with the new count
    const updatedHeading = headingText.replace(/\d+/, itemCount);
    if (updatedHeading !== headingText) {
      drawerHeading.textContent = updatedHeading;
    }
  }
  
  // Trigger cart icon update by dispatching events
  document.dispatchEvent(new CustomEvent('cartCountUpdated', { 
    detail: { count: itemCount } 
  }));
  
  console.log(`Cart count updated to: ${itemCount}`);
}

// Function to open cart drawer using multiple methods for compatibility
function openCartDrawer() {
  console.log('Attempting to open cart drawer...');
  
  // Method 1: Try to find and trigger cart drawer open via cart-drawer element
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    // Try different ways to open the cart drawer
    if (typeof cartDrawer.open === 'function') {
      console.log('Opening cart drawer via cartDrawer.open()');
      cartDrawer.open();
      return;
    }
    
    // Try to trigger click on cart icon to open drawer
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      console.log('Opening cart drawer via cart icon click');
      cartIcon.click();
      return;
    }
  }
  
  // Method 2: Try to find cart link and click it
  const cartLink = document.querySelector('a[href*="/cart"], .header__icon--cart, [data-cart-url]');
  if (cartLink) {
    console.log('Opening cart via cart link click');
    cartLink.click();
    return;
  }
  
  
  // Method 3: Try theme-specific cart drawer methods
  if (window.theme && window.theme.cartDrawer) {
    if (typeof window.theme.cartDrawer.open === 'function') {
      console.log('Opening cart drawer via theme.cartDrawer.open()');
      window.theme.cartDrawer.open();
      return;
    }
  }
  
  
  // Method 4: Try to dispatch custom event for cart opening
  console.log('Dispatching cart open event');
  document.dispatchEvent(new CustomEvent('cart:open'));
  document.dispatchEvent(new CustomEvent('cart:show'));
  document.dispatchEvent(new CustomEvent('cartDrawer:open'));
  
  // Method 5: Log if no cart drawer methods worked
  setTimeout(() => {
    console.log('No cart drawer methods worked - staying on current page');
  }, 1000);
}


// Export functions for global use
window.customModal = {
  open: openModal,
  close: closeModal,
  changeImage: changeModalImage,
  updateCartCount: updateCartCountImmediately,
  openCartDrawer: openCartDrawer
};
  